import React, { useEffect } from "react";
//import { useSetRecoilState } from 'recoil';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { showBannerState } from "src/store/global/bannerShowState";
import { headerShowState } from "src/store/global/headerShowState";
import Container from "@mui/material/Container";
import { useStylesBannerHome } from "src/layout/BannerHome";
import { applyBaseStylesAppRouterState } from "src/store/global/generalState";
import { Card, CardContent, Typography } from "@mui/material";
import FormSearch from "src/SearchHours/FormSearch";
import FormSearchImagenologia from "src/SearchHours/FormSearchImagenologia";
import FormSearchProcedimiento from "src/SearchHours/FormSearchProcedimiento"
import SearchHoursSiteOficial from "src/shared/components/buttons/SearchHoursSiteOficial";
import useSearchHours from "src/SearchHours/hooks/useSearchHours";

import { filterSearchSelectedState, isChangeFormSearchState } from "src/SearchHours/state/atoms"

import { useTheme } from "@emotion/react";
import TabsCustom from "src/shared/components/tabs/TabsCustom";
import { activeTabSearchFromPageState } from "./state/atoms";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { encryptJSON, decryptJSON, encryptString } from 'src/shared/global/cryptoJSUtilities';
import { Height } from "@mui/icons-material";
import { validateRutChilean } from "src/shared/global/helpers";
import { userState } from "src/store/user/userState";
import { valuesFormReservationGuestState } from "src/Patient/state/atoms";

const SearchFromPageOficial = () => {
  const classes = useStylesBannerHome();
  const setShowHeader = useSetRecoilState(headerShowState);
  const setShowBanner = useSetRecoilState(showBannerState);
  const setApplyBaseStylesAppRouter = useSetRecoilState(
    applyBaseStylesAppRouterState
  );
  const [activeTabSearchFromPage, setActiveTabSearchFromPage] = useRecoilState(
    activeTabSearchFromPageState
  );
  const { isEmptyFilters , isEmptyFiltersImagenologia, isEmptyFiltersProcedimiento } = useSearchHours();

  const setFilterSearchSelected = useSetRecoilState(filterSearchSelectedState);

  const theme = useTheme();

  useEffect(() => {
    setShowHeader(false);
    setShowBanner(false);
    setApplyBaseStylesAppRouter(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const onSearch = () => {

    const objEncryptJson = encryptJSON(filterSearchSelected);
    window.open(
      `${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda?ext=${objEncryptJson}`,
      "_blank"
    );
    //---
    // window.open(
    //   `${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda`,
    //   "_blank"
    // );

  };

  const onSearchImagenologia = () => {
    const objEncryptJson = encryptJSON(filterSearchSelected);
    window.open(
      `${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda-imagenologia?ext=${objEncryptJson}`,
      "_blank"
    );    
    // window.open(
    //   `${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda-imagenologia`,
    //   "_blank"
    // );
  };

  const onSearchProcedimiento = () => {
    const objEncryptJson = encryptJSON(filterSearchSelected);
    window.open(
      `${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda-procedimiento?ext=${objEncryptJson}`,
      "_blank"
    );    
    // window.open(
    //   `${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda-imagenologia`,
    //   "_blank"
    // );
  };
  const resetFilterSearchSelected = useResetRecoilState(filterSearchSelectedState);

  const handleChange = (event, newValue) => {
    //setReservationsRecents([])
    //setReservationsHistory([])
    resetFilterSearchSelected();
    if(newValue == 1){
    }else{

    //   setFilterSearchSelected((current) => ({
    //     ...filterSearchSelected,
    //     sucursalSelected: {
    //       value: '',
    //       code: null,
    //       showInFilter: true,
    //       canDeleteFilter: false
    //   },   
    //   specialitySelected: {
    //     value: '',
    //     code: null,
    //     showInFilter: true,
    //     canDeleteFilter: false
    //     },
    //     professionalSelected: {
    //         value: '',
    //         code: null,
    //         showInFilter: true,
    //         canDeleteFilter: true
    //     },
    //     covenantSelected: {
    //         value: '',
    //         code: null,
    //         showInFilter: true,
    //         canDeleteFilter: true
    //     }

    // }))

    }

    setActiveTabSearchFromPage(newValue);
  };

  const valuesFormReservationGuest = useRecoilValue(valuesFormReservationGuestState);
  const user = useRecoilValue(userState);

  const disableButton = () => {
    const { professionalSelected, specialitySelected, examenSelected, procedimientoSelected, servicioSelected } = filterSearchSelected;
    const { uprRut } = valuesFormReservationGuest;
    const isValidRut = uprRut ? validateRutChilean(uprRut).ok : false;
    let flag = false;
    if (activeTabSearchFromPage === "1") {
      flag = (professionalSelected.value !== '' || specialitySelected.value !== '') && (user.isAuthenticated || isValidRut)
    } else if (activeTabSearchFromPage === "2") {
      flag = (examenSelected.value !== '' && filterSearchSelected.tipoExamenSelected.value !== '') && (user.isAuthenticated || isValidRut)
    } else if (activeTabSearchFromPage === "3") {
      flag = (procedimientoSelected.value !== '' && servicioSelected.value !== '') && (user.isAuthenticated || isValidRut)
    }
    
    return !flag;
  }
    
  return (
    <Container
      disableGutters
      maxWidth={false}
      style={{ width: "100%", padding: 0 }}
    >
      <Box sx={{ width: "100%",  typography: "body1" }}>
        <TabContext value={activeTabSearchFromPage}>
          <Box sx={{}}>
            <TabsCustom
              theme={theme}
              onChange={handleChange}
              aria-label="lab API tabs example"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile 
            >
              <Tab label="Hora Médica" value="1" />
              <Tab label="Imagenología" value="2" />
              <Tab label="Procedimientos" value="3" />
            </TabsCustom>
          </Box>
          <TabPanel value="1" style={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0 , paddingBottom: 0 }}>
            <div className={classes.root} style={{ margin: 0, padding: 0 }}>
              <Card
                sx={{
                  background: "transparent",
                  padding: "16px",
                  boxShadow: "none",
                  width: "100%",
                }}
              >
                <CardContent>
                  <Typography
                    textAlign="start"
                    variant="h1"
                    color="white"
                    mb={3}
                  >
                    RESERVA TU HORA
                  </Typography>
                  <FormSearch
                    size="medium"
                    md={3}
                    styles={{
                      input:{
                        backgroundColor: "white",
                        borderRadius: "5px",
                        padding:"17px"
                      },
                      autocomplete: {
                        backgroundColor: "white",
                        borderRadius: "5px",
                      },
                      label: {
                        color: "white",
                        fontSize: "15px",
                        fontWeight: 700,
                      },
                    }}
                    buttonSearch={
                      <SearchHoursSiteOficial
                        onClick={onSearch}
                        disabled={disableButton()}
                      />
                    }
                  />
                </CardContent>
              </Card>
            </div>
          </TabPanel>
          <TabPanel value="2" style={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0 , paddingBottom: 0 }}>
          <div className={classes.root} style={{ margin: 0, padding: 0 }}>
              <Card
                sx={{
                  background: "transparent",
                  padding: "16px",
                  boxShadow: "none",
                  width: "100%",
                }}
              >
                <CardContent>
                  <Typography
                    textAlign="start"
                    variant="h1"
                    color="white"
                    mb={3}
                  >
                    RESERVA TU HORA
                  </Typography>
                  <FormSearchImagenologia
                    size="medium"
                    md={3}
                    styles={{
                      input:{
                        backgroundColor: "white",
                        borderRadius: "5px",
                        padding:"17px"
                      },
                      autocomplete: {
                        backgroundColor: "white",
                        borderRadius: "5px",
                      },
                      label: {
                        color: "white",
                        fontSize: "15px",
                        fontWeight: 700,
                      },
                    }}
                    buttonSearch={
                      <SearchHoursSiteOficial
                        onClick={onSearchImagenologia}
                        disabled={disableButton()}
                      />
                    }
                  />
                </CardContent>
              </Card>
            </div>
          </TabPanel>
          <TabPanel value="3" style={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0 , paddingBottom: 0 }}>
          <div className={classes.root} style={{ margin: 0, padding: 0 }}>
              <Card
                sx={{
                  background: "transparent",
                  padding: "16px",
                  boxShadow: "none",
                  width: "100%",
                }}
              >
                <CardContent>
                  <Typography
                    textAlign="start"
                    variant="h1"
                    color="white"
                    mb={3}
                  >
                    RESERVA TU HORA
                  </Typography>
                  <FormSearchProcedimiento
                    size="medium"
                    md={3}
                    styles={{
                      input:{
                        backgroundColor: "white",
                        borderRadius: "5px",
                        padding:"17px"
                      },
                      autocomplete: {
                        backgroundColor: "white",
                        borderRadius: "5px",
                      },
                      label: {
                        color: "white",
                        fontSize: "15px",
                        fontWeight: 700,
                      },
                    }}
                    buttonSearch={
                      <SearchHoursSiteOficial
                        onClick={onSearchProcedimiento}
                        disabled={disableButton()}
                      />
                    }
                  />
                </CardContent>
              </Card>
            </div>
          </TabPanel>          
        </TabContext>
      </Box>
    </Container>
  );
};

export default SearchFromPageOficial;
